module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_vm._v("This is for India Grey, Natalie Rivers"), _c('br'), _vm._v("and Heidi Rice—I couldn’t do this job without any of"), _c('br'), _vm._v("you, and it wouldn’t be half as much fun. Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("(My phone company also extends its thanks"), _c('br'), _vm._v("for keeping them in business.)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b4dceb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781460346396_epub_ded_r1.vue
// module id = 66
// module chunks = 0